import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconSurroundingsLakeComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeWidth={1.0}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.33.38h-.28a11.63 11.63 0 1 0 0 23.25 10.95 10.95 0 0 0 10.17-6.83l.6-1.46a1.5 1.5 0 0 0-1.09-2.02l-6.91-1.22 7.22-.7a1.85 1.85 0 0 0 1.58-2.3A11.67 11.67 0 0 0 12.33.38Zm9.64 10.27-8.91.87 1.55-1.54a2.03 2.03 0 0 1 1.45-.6 1.25 1.25 0 0 0 1.24-1.25.5.5 0 0 1 .34-.47l.53-.18-.23-.71-.53.17a1.25 1.25 0 0 0-.86 1.19.5.5 0 0 1-.5.5 2.78 2.78 0 0 0-1.97.81l-1.27 1.27.22-.78c.23-.8.19-1.65-.12-2.42l-.32-.8a2.25 2.25 0 0 1 .08-1.85l.47-.94-.67-.34-.48.95a3.02 3.02 0 0 0-.1 2.45l.32.8a3 3 0 0 1 .1 1.95l-.45 1.6-1-.87A4.2 4.2 0 0 1 9.43 7.3a3.07 3.07 0 0 0-1.7-2.76l-.34.67a2.33 2.33 0 0 1 1.29 2.1 4.95 4.95 0 0 0 1.69 3.71l.18.17a8.93 8.93 0 0 0-2.32-.31c-.37 0-.73-.11-1.03-.32a2.6 2.6 0 0 0-1.45-.44H5.3v.76h.45c.37 0 .73.1 1.04.3.42.3.93.45 1.44.45.76 0 1.52.1 2.25.31l.8.22-1.02.85c-.38.31-.86.49-1.36.49a2.88 2.88 0 0 0-2.4 1.28l-.76 1.14.63.41.75-1.13a2.13 2.13 0 0 1 1.78-.95c.67 0 1.32-.24 1.84-.67l.94-.78c0 1.28.22 2.55.62 3.76.2.62.16 1.29-.13 1.87l-.45.9.67.34.45-.9a3.22 3.22 0 0 0 .17-2.45c-.3-.93-.5-1.9-.55-2.88l1.48 2.54a1.81 1.81 0 0 0 1.56.9 1.06 1.06 0 0 1 1.05 1.05v.45h.75v-.45a1.8 1.8 0 0 0-1.8-1.8 1.06 1.06 0 0 1-.91-.53l-1.8-3.1 8.8 1.56a.74.74 0 0 1 .53 1l-.59 1.45a10.2 10.2 0 0 1-9.48 6.36 10.88 10.88 0 0 1 0-21.75h.28A10.92 10.92 0 0 1 22.89 9.3a1.1 1.1 0 0 1-.92 1.36Z"
          fill="#000"
        />
      </svg>
    </SvgIcon>
  );
};

IconSurroundingsLakeComponent.displayName = 'IconSurroundingsLake';

const IconSurroundingsLake = React.memo(IconSurroundingsLakeComponent);

export default IconSurroundingsLake;
